import React, { SetStateAction, useEffect, useState } from 'react'
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'
import { removerAcentos } from '../../../../../../utils'
import { Box } from '../../../../../../Components/CustomUi/box'
import { Inline } from '../../../../../../Components/CustomUi/inline'
import Input from '../../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../../Components/CustomUi/deleteButton'
import { Empty } from 'antd'
import Carregando from '../../../../../../Components/CustomUi/loading'


//PROPS
interface Props {
  loading: boolean
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  listar_catalogo: any[]
  abrir: Function
  permissao: ItensPerUserLogged
  editarCadastro: Function
  deletar: Function
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  buscarTabela: string
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
}

export const TabelaCatalogoPragas: React.FC<Props> = ({
  loading,
  page,
  setPage,
  setPagination,
  total,
  listar_catalogo,
  abrir,
  permissao,
  editarCadastro,
  deletar,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  buscarTabela,
  setBuscarTabela
}) => {
  function buscarPatrimonios(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <Box style={{ height: 'calc(100vh - 180px)' }} gap={10}>
      <Inline alignItems='center'>
        <Input
          placeholder='Buscar Catálogo de pragas, doenças e plantas daninhas'
          value={buscarTabela}
          onChange={setBuscarTabela}
        />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Novo
        </ButtonCustom>
      </Inline>
      <HeaderTable
        itens={[
          { valor: 'Nome', width: 'calc(100% - 700px)' },
          { valor: 'Nome científico', width: '350px' },
          { valor: 'Tipo', width: '170px' },
          { valor: 'Ações', width: '180px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: (listar_catalogo ?? []).length < 8 && 'calc(100vh - 170px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(listar_catalogo ?? []).filter(buscarPatrimonios(buscarTabela)).map(({ cod, nome, nome_cientifico, categoria_nome }) => {
            return (
              <RowTable key={cod} onDoubleClick={() => {}}>
                <RowItem fontSize={13} width={'calc(100% - 695.1px)'}>
                  {nome}
                </RowItem>
                <RowItem fontSize={13} width={'351px'}>
                  {nome_cientifico}
                </RowItem>
                <RowItem fontSize={13} width={'169.1px'}>
                  {categoria_nome}
                </RowItem>

                <RowItem width={'175px'} gap={10}>
                  <DeleteButton
                    open={confirmar_exclusao && id_item_atual === cod}
                    trigger={setConfirmar_exclusao}
                    onTrigger={() => {
                      setId_item_atual(cod)
                      setNome_item_atual(nome)
                    }}
                    loading={fake_loading}
                    message={`o item ${nome} será excluido!`}
                    deleteds={[nome]}
                    onDelete={() => {
                      deletar(cod)
                    }}
                    disabled={fake_loading}
                    disabledTrigger={permissao?.exclusao === 0}
                  />
                  <ButtonCustom
                    icon={<FontAwesomeIcon icon={faEdit} />}
                    onClick={() => editarCadastro(cod)}
                    disabled={permissao?.alteracao === 0 && permissao?.acesso === 0}
                  >
                    Editar
                  </ButtonCustom>
                </RowItem>
              </RowTable>
            )
          })}
        </Render>

        <Render condition={listar_catalogo.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando catálogo de pragas...'
            justifyContent='center'
            height={200}
            size='default'
          />
        </Render>
      </BodyTable>
    </Box>
  )
}
